import { useEffect } from 'react'
import { isMobileSafari, isSafari } from 'react-device-detect'

const useSafariForceBackRender = (listener: () => void) => {
  useEffect(() => {
    const handlePopState = (event) => {
      if (event.persisted) {
        if (isMobileSafari && isSafari) listener()
      }
    }

    /// Force refetch data in Mobile Safari base on Privacy Setting prevent reloading when navigate back from external site
    window.addEventListener('pageshow', handlePopState)

    return () => {
      window.removeEventListener('pageshow', handlePopState)
    }
  }, [isMobileSafari, isSafari])
}

export default useSafariForceBackRender
